<template>
  <aside class="guard-call-panel">
    <div class="guard-call-panel__partner-row">
      <span class="guard-call-panel__role-badge">{{ sublocationName }}</span>
      <div class="guard-call-panel__partner-chip">
        <svg viewBox="0 0 24 24">
          <path d="M12 2 3 6v6c0 5 4 8.5 9 10 5-1.5 9-5 9-10V6l-9-4z" />
        </svg>
        <span>Puma seguridad</span>
      </div>
    </div>

    <div class="guard-call-panel__feed-card">
      <div class="guard-call-panel__feed-visual" ref="screen">
        <video
          class="guard-call-panel__feed-video"
          src="/videoVigilante.mp4"
          autoplay
          loop
          muted
          playsinline
          v-show="isPreCall"
        ></video>
        <div class="guard-call-panel__feed-overlay" v-show="isPreCall"></div>
        <div class="guard-call-panel__feed-live" v-show="isPreCall">
          <span class="guard-call-panel__feed-live-dot"></span
          ><span>En vivo</span>
        </div>
        <div class="guard-call-panel__feed-name-row" v-show="isPreCall">
          <div class="guard-call-panel__feed-name">Central Fuse</div>
          <div class="guard-call-panel__feed-role">Vigilante Virtual</div>
        </div>
        <div class="guard-call-panel__calling-overlay" v-if="status === 'calling'">
          <div class="guard-call-panel__calling-visual">
            <svg viewBox="0 0 24 24">
              <path
                d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2.1.7 3a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.2-1.3a2 2 0 0 1 2.1-.5c1 .3 2 .6 3 .7a2 2 0 0 1 1.7 2z"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="guard-call-panel__calling-title">Llamando a recepción…</p>
          <p class="guard-call-panel__calling-sub">Un vigilante te atenderá en unos segundos</p>
          <button
            class="guard-call-panel__calling-hangup"
            @click="hangUp"
          >
            Colgar
          </button>
        </div>
      </div>
      <div class="guard-call-panel__feed-footer">
        <div class="guard-call-panel__online-pill">
          <span class="guard-call-panel__online-dot"></span>En línea ahora
        </div>
      </div>
      <div class="guard-call-panel__status-panel" v-if="isInCall">
        <div class="guard-call-panel__status-info">
          <div class="guard-call-panel__status-visual"><HandOutIcon /></div>
          <div class="guard-call-panel__status-counter">
            {{ counter }} segundos
          </div>
        </div>
        <button class="guard-call-panel__hangup-btn" @click="hangUp">
          Colgar
        </button>
      </div>
      <div class="guard-call-panel__missed-panel" v-if="isMissed">
        <h3 class="guard-call-panel__missed-title">Llamada perdida</h3>
        <p class="guard-call-panel__missed-subtitle">El guardia no respondió</p>
        <div class="guard-call-panel__missed-card">
          <KeyboardCallbackForm
            :sublocationId="sublocationId"
            @close="onMissedCallClose"
          />
        </div>
      </div>
      <div class="guard-call-panel__error-panel" v-if="isError">
        <h3 class="guard-call-panel__error-title">No se pudo conectar</h3>
        <p class="guard-call-panel__error-subtitle">Intenta nuevamente</p>
        <div class="guard-call-panel__error-actions">
          <button class="guard-call-panel__error-retry" @click="retryCall">
            Reintentar
          </button>
          <button class="guard-call-panel__error-cancel" @click="hangUp">
            Cancelar
          </button>
        </div>
      </div>
    </div>
    <div class="guard-call-panel__call-section" v-if="status === 'idle'">
      <button
        class="guard-call-panel__call-btn"
        @click="callGuard"
      >
        <span class="guard-call-panel__call-icon-wrap">
          <svg viewBox="0 0 24 24">
            <path
              d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2.1.7 3a2 2 0 0 1-.5 2.1L8 10a16 16 0 0 0 6 6l1.2-1.3a2 2 0 0 1 2.1-.5c1 .3 2 .6 3 .7a2 2 0 0 1 1.7 2z"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="guard-call-panel__call-text">
          <span class="guard-call-panel__call-btn-title">Llamar a recepción</span>
          Te atendemos en segundos
        </span>
      </button>
      <div class="guard-call-panel__call-availability">Disponible 24/7</div>
    </div>
  </aside>
</template>

<script>
import HandOutIcon from "@/components/shared/icons/HandOutIcon.vue";
import {
  CALL_DURATION_SEC,
  RING_TIMEOUT_SEC,
  HANGUP_KEY,
  JITSI_CALL_BASE_CONFIG,
} from "../constants";
import KeyboardCallbackForm from "./KeyboardCallbackForm.vue";

export default {
  name: "CallPanel",
  components: { HandOutIcon, KeyboardCallbackForm },
  emits: ["on-call", "hangUp"],
  props: {
    sublocationId: {
      type: String,
      required: true,
    },
    sublocationName: {
      type: String,
      required: true,
    },
    connectionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      counter: CALL_DURATION_SEC,
      status: "idle",
    };
  },
  created() {
    this.jitsiApi = null;
    this.callTimer = null;
    this.ringTimer = null;
    this.ringStartTime = null;
    this.audio = null;
    this.keyHandler = null;
  },
  mounted() {
    this.subscribeToGuardWsChannel();
  },
  beforeDestroy() {
    this.cleanup();
    this.unsubscribeFromGuardWsChannel();
  },
  computed: {
    isPreCall() {
      return this.status === "idle" || this.status === "calling";
    },
    isInCall() {
      return this.status === "connecting" || this.status === "active";
    },
    isMissed() {
      return this.status === "missed";
    },
    isError() {
      return this.status === "error";
    },
  },
  watch: {
    status(newStatus) {
      this.$emit(
        "on-call",
        ["calling", "connecting", "active"].includes(newStatus)
      );
    },
  },
  channels: {
    VirtualGuardChannel: {
      received({ data }) {
        if (data.connection_id === this.connectionId) return;

        if (data.message === "answerCall" && data.answer_call) {
          this.onCallAnswered();
          return;
        }

        if (data.message === "hangUp" && data.calling === false) {
          this.hangUp();
          return;
        }

        if (data.message === "notifyCallEnded" && data.notify_call_ended) {
          this.hangUp();
          return;
        }
      },
    },
  },
  methods: {
    subscribeToGuardWsChannel() {
      this.$cable.subscribe({
        channel: "VirtualGuardChannel",
        room: `room_virtual_guard_${this.sublocationId}`,
        sublocation_id: this.sublocationId,
      });
    },
    unsubscribeFromGuardWsChannel() {
      this.$cable.unsubscribe("VirtualGuardChannel");
    },
    notifyCable(message, extra = {}) {
      this.$cable.perform({
        channel: "VirtualGuardChannel",
        action: "send_message",
        data: {
          room: `room_virtual_guard_${this.sublocationId}`,
          message,
          sublocation_id: this.sublocationId,
          connection_id: this.connectionId,
          ...extra,
        },
      });
    },
    async getToken() {
      const response = await this.$http.get("digital_guard/generate_jwt", {
        params: {
          sublocation_id: this.sublocationId,
        },
        headers: {
          "X-Device-ID": this.getDeviceId(),
          Authorization: process.env.VUE_APP_JITSI_TOKEN_AUTHORIZATION,
        },
      });
      if (!response.ok) {
        throw new Error(`JWT request failed: ${response.status}`);
      }
      return response.body.data;
    },
    async setUpVideoCall() {
      try {
        const token = await this.getToken();
        if (!token) throw new Error("No token received");
        this.launchVideoCall(token);
      } catch (e) {
        console.error("Failed to set up video call", e);
        this.status = "error";
      }
    },
    retryCall() {
      this.status = "connecting";
      this.setUpVideoCall();
    },
    callGuard() {
      if (this.status !== "idle") return;
      this.status = "calling";

      this.playRingAudio();

      this.notifyCable("call", { calling: true });

      this.ringStartTime = Date.now();

      this.ringTimer = setInterval(() => {
        if (Date.now() - this.ringStartTime > RING_TIMEOUT_SEC * 1000) {
          this.hangUp();
          this.status = "missed";
          return;
        }
      }, 1000);
    },
    onCallAnswered() {
      if (this.status !== "calling") return;
      this.stopAudio();
      this.clearRingTimer();
      this.status = "connecting";

      this.setUpVideoCall();
    },
    launchVideoCall(token) {
      this.notifyCable("answerCall", { answer_call: true });

      const [options, domain] = this.buildCallOptions(token);

      // create jitsi instance and videoconference event handlers

      this.jitsiApi = new window.JitsiMeetExternalAPI(domain, options);

      this.jitsiApi.addEventListener("readyToClose", this.hangUp);

      this.jitsiApi.addEventListener(
        "videoConferenceJoined",
        this.onVideoConferenceJoined
      );

      this.keyHandler = (e) => {
        if (e.code !== HANGUP_KEY) return;
        if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA")
          return;
        this.hangUp();
      };
      document.addEventListener("keydown", this.keyHandler);
    },
    onVideoConferenceJoined() {
      this.status = "active";
      this.startCountdown();
    },
    startCountdown() {
      this.counter = CALL_DURATION_SEC;
      this.callTimer = setInterval(() => {
        this.counter--;
        if (this.counter <= 0) this.hangUp();
      }, 1000);
    },
    hangUp() {
      if (this.status === "calling") {
        this.notifyCable("hangUp", { calling: false });
      } else if (this.status === "connecting" || this.status === "active") {
        this.notifyCable("notifyCallEnded", { notify_call_ended: true });
      }
      this.cleanup();
      this.status = "idle";
      this.$emit("hangUp");
    },
    onMissedCallClose() {
      this.status = "idle";
    },
    buildCallOptions(token) {
      const domain = process.env.VUE_APP_JITSI_URL;
      const options = {
        ...JITSI_CALL_BASE_CONFIG,
        roomName: `room_virtual_guard_${this.sublocationId}`,
        parentNode: this.$refs.screen,
        jwt: token,
      };
      return [options, domain];
    },
    playRingAudio() {
      this.audio = new Audio(require("@/assets/audio/calling.mp3"));
      this.audio.play();
    },
    stopAudio() {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.audio = null;
      }
    },
    clearRingTimer() {
      if (this.ringTimer) {
        clearInterval(this.ringTimer);
        this.ringTimer = null;
      }
    },
    cleanup() {
      this.stopAudio();
      this.clearRingTimer();
      if (this.callTimer) {
        clearInterval(this.callTimer);
        this.callTimer = null;
      }
      if (this.keyHandler) {
        document.removeEventListener("keydown", this.keyHandler);
        this.keyHandler = null;
      }
      if (this.jitsiApi) {
        try {
          this.jitsiApi.dispose();
        } catch (e) {
          console.error("Something went wrong connecting to jitsi", e);
        }
        this.jitsiApi = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles";

.guard-call-panel {
  @include guard-panel-guard;

  &__partner-row {
    @include guard-flex-center-between;
    flex-shrink: 0;
  }
  &__role-badge {
    font-size: 0.68rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: $guard-mute-blue;
    font-weight: 500;
  }
  &__partner-chip {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    background: rgba(#fff, 0.06);
    border: 1px solid rgba(#fff, 0.12);
    padding: 0.3rem 0.6rem;
    border-radius: $guard-radius-sm;
    svg {
      width: 0.85rem;
      height: 0.85rem;
      stroke: $guard-cyan-500;
      fill: none;
      stroke-width: 1.7;
    }
    span {
      font-size: 0.64rem;
      font-weight: 500;
      letter-spacing: 0.03em;
      color: $guard-mute-blue-text;
    }
  }

  &__feed-card {
    @include guard-card-dark;
  }
  &__feed-visual {
    position: relative;
    flex: 1;
    min-height: 0;
    background: #000;
    overflow: hidden;
  }
  &__feed-video {
    position: absolute;
    inset: 0;
    width: 100% !important;
    max-width: none !important;
    height: 100%;
    object-fit: cover;
  }
  &__feed-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.45) 0%,
      transparent 18%,
      transparent 68%,
      rgba(0, 0, 0, 0.75) 100%
    );
    pointer-events: none;
    z-index: $guard-z-feed-overlay-gradient;
  }
  &__feed-live {
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    display: flex;
    align-items: center;
    gap: 0.35rem;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(#fff, 0.18);
    padding: 0.28rem 0.6rem;
    border-radius: $guard-radius-sm;
    z-index: $guard-z-feed-live;
    span {
      font-size: 0.65rem;
      letter-spacing: 0.06em;
      color: #fff;
      text-transform: uppercase;
      font-weight: 500;
    }
  }
  &__feed-live-dot {
    @include guard-dot($guard-accent-red, 0.42rem, 1.6s);
  }
  &__feed-name-row {
    position: absolute;
    bottom: 0.85rem;
    left: 0.9rem;
    right: 0.9rem;
    z-index: $guard-z-feed-live;
  }
  &__feed-name {
    font-weight: 600;
    font-size: 1.2rem;
    color: #fff;
    line-height: 1.1;
  }
  &__feed-role {
    font-size: 0.78rem;
    color: $guard-cyan-500;
    margin-top: 0.2rem;
    font-weight: 500;
  }
  &__feed-visual ::v-deep iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: none;
    z-index: $guard-z-feed-overlay;
  }
  &__feed-footer {
    flex-shrink: 0;
    @include guard-flex-center-between;
    padding: 0.6rem 0.9rem;
    background: $guard-navy-900;
  }
  &__online-pill {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.72rem;
    color: $guard-status-green-text;
    font-weight: 500;
    letter-spacing: 0.02em;
  }
  &__online-dot {
    @include guard-dot($guard-accent-green, 0.4rem, 2.2s);
  }

  &__status-panel {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.6rem;
    padding: 0.6rem 0.9rem;
    background: $guard-navy-900;
    border-radius: 0 0 $guard-radius-lg $guard-radius-lg;
  }
  &__status-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  &__status-visual {
    width: 2rem;
    height: 2rem;
    border-radius: $guard-radius-sm;
    background: rgba($guard-cyan-500, 0.15);
    border: 1px solid rgba($guard-cyan-500, 0.35);
    @include guard-flex-center;
    flex-shrink: 0;
    ::v-deep svg {
      width: 1rem;
      height: 1rem;
    }
  }
  &__status-counter {
    font-size: 0.78rem;
    color: $guard-mute-blue-text;
    font-weight: 400;
  }
  &__hangup-btn {
    @include guard-button(
      $guard-accent-red-btn,
      $guard-accent-red-btn,
      $guard-radius-sm
    );
    padding: 0.5rem 1.2rem;
    font-size: 0.82rem;
    &:hover {
      opacity: 0.92;
    }
  }

  &__call-section {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  &__call-btn {
    @include guard-button(
      $guard-cyan-500,
      $guard-cyan-600,
      $guard-radius-md,
      #fff,
      $guard-shadow-call-btn
    );
    padding: 1rem 1.1rem;
    display: flex;
    align-items: center;
    gap: 0.85rem;
    width: 100%;
  }
  &__call-icon-wrap {
    width: 2.7rem;
    height: 2.7rem;
    border-radius: $guard-radius-sm;
    background: rgba(#fff, 0.2);
    @include guard-flex-center;
    flex-shrink: 0;
    svg {
      width: 1.4rem;
      height: 1.4rem;
      stroke: #fff;
      fill: none;
      stroke-width: 1.8;
    }
  }
  &__call-text {
    text-align: left;
  }
  &__call-btn-title {
    font-weight: 600;
    font-size: 1.08rem;
    display: block;
  }
  &__call-availability {
    text-align: center;
    font-size: 0.68rem;
    color: $guard-mute-blue-dark;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  &__calling-overlay {
    position: absolute;
    inset: 0;
    background: rgba(10, 20, 40, 0.92);
    backdrop-filter: blur(3px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.4rem;
    z-index: $guard-z-call-overlay;
    border-radius: $guard-radius-lg;
    gap: 0.3rem;
  }
  &__calling-visual {
    width: 4.6rem;
    height: 4.6rem;
    border-radius: $guard-radius-md;
    background: rgba($guard-cyan-500, 0.15);
    border: 1px solid rgba($guard-cyan-500, 0.35);
    @include guard-flex-center;
    position: relative;
    margin-bottom: 0.9rem;

    &::before {
      content: "";
      position: absolute;
      inset: -6px;
      border-radius: $guard-radius-lg;
      border: 2px solid $guard-cyan-500;
      opacity: 0.4;
      @include guard-ring-anim;
    }
    svg {
      width: 2rem;
      height: 2rem;
      stroke: $guard-cyan-500;
      fill: none;
      stroke-width: 1.7;
    }
  }
  &__calling-title {
    font-weight: 600;
    font-size: 1.08rem;
    color: #fff;
    margin: 0;
  }
  &__calling-sub {
    font-size: 0.84rem;
    color: $guard-mute-blue-text;
    margin: 0 0 0.9rem;
    font-weight: 400;
  }
  &__calling-hangup {
    @include guard-button(
      $guard-accent-red-btn,
      $guard-accent-red-btn,
      $guard-radius-sm
    );
    padding: 0.75rem 1.8rem;
    font-size: 0.9rem;
    &:hover { opacity: 0.92; }
  }

  &__missed-panel {
    position: absolute;
    inset: 0;
    background: rgba(10, 20, 40, 0.92);
    backdrop-filter: blur(3px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.4rem;
    z-index: $guard-z-call-overlay;
    border-radius: $guard-radius-lg;
    gap: 0.6rem;
  }
  &__missed-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #fff;
    margin: 0;
  }
  &__missed-subtitle {
    font-size: 0.8rem;
    color: $guard-mute-blue-text;
    margin: 0 0 0.6rem;
  }
  &__missed-card {
    width: 100%;
    max-width: 20rem;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: left;
  }

  &__error-panel {
    position: absolute;
    inset: 0;
    background: rgba(10, 20, 40, 0.92);
    backdrop-filter: blur(3px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 1.4rem;
    z-index: $guard-z-call-overlay;
    border-radius: $guard-radius-lg;
    gap: 0.6rem;
  }
  &__error-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: $guard-accent-red;
    margin: 0;
  }
  &__error-subtitle {
    font-size: 0.8rem;
    color: $guard-mute-blue-text;
    margin: 0 0 0.6rem;
  }
  &__error-actions {
    display: flex;
    gap: 0.6rem;
  }
  &__error-retry {
    @include guard-button(
      $guard-cyan-500,
      $guard-cyan-600,
      $guard-radius-sm
    );
    padding: 0.6rem 1.2rem;
    font-size: 0.86rem;
  }
  &__error-cancel {
    @include guard-button(
      $guard-accent-red-btn,
      $guard-accent-red-btn,
      $guard-radius-sm
    );
    padding: 0.6rem 1.2rem;
    font-size: 0.86rem;
  }
}
</style>
